import { useCallback } from 'react';
import { Link } from 'gatsby';
import useInternalLinks from '@/hooks/useInternalLinks';
import { domToReact, type Element, type DOMNode } from 'html-react-parser';
import { getTitleFromReactElements } from '../utils';

const useResolveRichTextInternalLink = () => {
  const getInternalLinkURLByCodename = useInternalLinks();

  return useCallback(
    (link: Queries.kontent_item_rich_text_element_link, dom: Element): JSX.Element | null => {
      const internalLinkURL = getInternalLinkURLByCodename(link.codename);

      if (!internalLinkURL) {
        return null;
      }

      const domElements = domToReact(dom.children as DOMNode[], { trim: true });
      const title = getTitleFromReactElements(domElements as string | JSX.Element);

      return (
        <Link to={internalLinkURL} title={title}>
          {domElements}
        </Link>
      );
    },
    [getInternalLinkURLByCodename]
  );
};

export default useResolveRichTextInternalLink;
